import http from '../lib/http'
const authorization = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8';
// eslint-disable-next-line new-cap
let api = new http({
    // 省列表
    getProvinceLists:{
        url:'/api/user/area/province/list',
        method: 'get',
        options: {
            headers: {
                // authorization,
            }
        }
    },
    // 市列表
    getCityLists:{
        url:'/api/user/area/province/getCity',
        method: 'get',
        options: {
            headers: {
                // authorization,
            }
        }
    },
    // 区县列表
    getDistrictLists:{
        url:'/api/user/area/province/city/listDistrict',
        method: 'get',
        options: {
            headers: {
                // authorization,
            }
        }
    },
    // 网点列表
    getNationalSubsidyOutlets:{
        url:'/api/user/org/outlet/getNationalSubsidyOutlets',
        method: 'post',
        options: {
            headers: {
                authorization,
                'Content-Type': 'application/json',
            }
        }
    },
    // 获取服务导购
    getWechatQrCode:{
        url:'/api/market-scrm/guide/wechatQrCode',
        method: 'get',
        options: {
            headers: {
                // authorization,
            }
        }
    },
})

export default api